module.exports = __webpack_public_path__ + "images/bridge.909a523fb0e2f51a54eb2687d9522714.svg";